import {GeofenceSiteGroupEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {GeofenceSiteGroupAction} from "./GeofenceSiteGroupActionMenu";
import {useGeofenceSiteGroupMutation} from "../../../hooks/useGeofenceSiteGroupMutation";

export type UseGeofenceSiteGroupActionProps = {}

export type UseGeofenceSiteGroupActionResult = {
  onGeofenceSiteGroupActionClick: (role: GeofenceSiteGroupEntity, action: GeofenceSiteGroupAction) => void;
}

export const useGeofenceSiteGroupAction = (props: UseGeofenceSiteGroupActionProps = {}): UseGeofenceSiteGroupActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteGeofenceSiteGroup,
  } = useGeofenceSiteGroupMutation()

  const _onGeofenceSiteGroupActionClick = useCallback((geofenceSiteGroup: GeofenceSiteGroupEntity, action: GeofenceSiteGroupAction) => {
    if (action === "EDIT") {
      navigate(`/geofence-site-groups/form`, {state: {id: geofenceSiteGroup.id}})
    } else if (action === "DELETE") {
      deleteGeofenceSiteGroup(geofenceSiteGroup.id, undefined)
    }
  }, [navigate, deleteGeofenceSiteGroup])

  return {
    onGeofenceSiteGroupActionClick: _onGeofenceSiteGroupActionClick
  }
}
